import { useSelector } from 'react-redux';
import { getHasDealReadOnlyPermission } from 'store/dealManagement/selectors/getHasDealReadOnlyPermission';

export const useHasDealReadOnlyPermission = (): boolean => {
  return useSelector(getHasDealReadOnlyPermission);
};
